// In case of statistics there are used default fragments as Pivot tables are meant to work with all fields... even hidden ones by default
import { addressInfoFrag } from '../../utils/type/address.common-type';

export const procedureStatisticsFrag = `
    client {
        id
        name
        surname
        titleAfterName
        titleBeforeName
        alias
        birthSurname
        birthdate
        insuranceNumber
    }
    birthdate
    age
    procedureCode
    procedureName
    customProcedureName
    primaryDiagnosisCode
    primaryDiagnosisName
    expertiseCode
    applications
    duration
    points
    price
    date
    sex
    address
    voucherFrom
    voucherTo
    primaryDiagnosisCode
    serviceAddress {
        ${addressInfoFrag}
    }
    permanentResidence {
        ${addressInfoFrag}
    }
    workplaceAddress {
        ${addressInfoFrag}
    }
    doctor {
        name
        surname
        titleAfterName
        titleBeforeName
    }
    user {
        name
        surname
        titleAfterName
        titleBeforeName
    }
    users {
        name
        surname
        titleAfterName
        titleBeforeName
    }
    doctorSpecialization
    insurance
    insuranceAbbr
    distance
    distanceFrom
    distanceTo
    transportType
    paymentForTransport
    voucherId
    voucherSequenceNumber
    visitId
    doctorRecordId
    note
    comment
    medication
    priceForPoint
    pointsPerMinute
`;

export const worksStatisticsFrag = `
    id
    person {
        name
        surname
        titleAfterName
        titleBeforeName
        alias
        birthSurname
        birthdate
    }
    workType
    permanentResidence {
        ${addressInfoFrag}
    }
    serviceAddress {
        ${addressInfoFrag}
    }
    dateFrom
    dateTo
    addressFrom {
        ${addressInfoFrag}
    }
    addressTo {
        ${addressInfoFrag}
    }
    distanceFrom
    distanceTo
    transportTimeFrom
    transportTimeTo
    insuranceAbbr
    user {
        name
        surname
        titleAfterName
        titleBeforeName
    }
    users {
        name
        surname
        titleAfterName
        titleBeforeName
    }
    folders {
        name
        surname
        titleAfterName
        titleBeforeName
    }
    transportType
    paymentForTransport
    employmentTypeName
    distance
    contactType
    note
    medication
    state
    documentsCount
    forms
    procedures {
        code
        applications
        voucherType
        voucherSequenceNumber
        voucherIssueDate
        voucherClosureDate
        voucherValidTo
        voucherIcpOfDoctor
        voucherDoctor
    }
    serviceId
    workloadType
    operationalReportType
    shift
    form
    priority
    description
`;

export const workersStatisticsFrag = `
    id
    user {
        id
        name
        surname
        titleAfterName
        titleBeforeName
    }
    contract
    workloadType
    workloadSize
    scopeOfWork
    employmentTypeName
    employmentGroup
    workplace
    dateFrom
    dateTo
`;

export const palliativePeriodStatisticsFrag = `
    id
    client {
        name
        surname
        titleAfterName
        titleBeforeName
        alias
        birthSurname
        birthdate
    }
    procedure {
        procedureCode
        procedureName
        customProcedureName
        primaryDiagnosisCode
        expertiseCode
        applications
        duration
        points
        price
        date
        sex
        address
        voucherFrom
        voucherTo
        primaryDiagnosisCode
        serviceAddress {
            ${addressInfoFrag}
        }
        permanentResidence {
            ${addressInfoFrag}
        }
        doctor {
            name
            surname
            titleAfterName
            titleBeforeName
        }
        doctorSpecialization
        insurance
        insuranceAbbr
        distance
        voucherId
        visitId
        priceForPoint
        pointsPerMinute
        workType
    }
    dateFrom
    dateTo
`;
